import { createQualifiedFetchSelector } from '@copilot/common/store/selectors/fetch';
import { CampaignMemberModel } from '@copilot/common/utils/campaignMember/models';
import { CAMPAIGN_MEMBERS } from '@copilot/common/utils/campaignMember/constant';

export const selectCampaignMembers =
	createQualifiedFetchSelector<CampaignMemberModel>(CAMPAIGN_MEMBERS);
